/*

 SugarWOD Cloud Code

 constants.js

 */

exports.SUGARWOD_APP_ID = "brf4DbPywBx3TTNhkupukItTHmcTQMFF88Vnfmvy";
exports.SUGARWOD_CLIENTKEY_JS = "1dNf5Y4GkArvbLJf5tTv2tE0ezeKZi7mBhf5b64a";

exports.ROLE_SYSMOD = "sysmod";

const SUGARWOD = "SugarWOD";

// parse-server cryptoUtils randomString(size)
exports.PARSE_OBJECT_ID_CHARS =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ" + "abcdefghijklmnopqrstuvwxyz" + "0123456789";
exports.PARSE_OBJECT_ID_LENGTH = 10;

exports.ATHLETE_ID_DEMO = "EuJgl0TjsG";

exports.ATHLETE_ID_JONATHAN_BUSCH_ZP = "hPFMXSEDMP";

exports.ATHLETE_ID_COURTNEY = "7mgzEnrrf5";

exports.ATHLETE_ID_HQ_ADMIN = "sncuBTZRE6";
exports.USER_ID_HQ_ADMIN = "nrwWSunn1v";

exports.TRACK_ID_HQ = "2qv1VeuMNz";

const AFFILIATE_ID_HQ = "hEvyyT2IQA";
exports.CUSTOMER_ID_HQ = "zhN9S1cXQH";
exports.AFFILIATE_ID_ROOTS = "4vMS6B7sWb";
exports.AFFILIATE_ID_ETHOS = "llEH8dbF7F";
exports.AFFILIATE_ID_DAXKO = "0sAAY2echD";
exports.AFFILIATE_ID_SUGARWOD_TEST_1 = "rkqktBJLik";

const EMAIL_TECHNICAL_ADMIN = "kimball.hewett@daxko.com";

const SUGARWOD_MARKETPLACE_NAME = "SugarWOD Marketplace";

exports.REFERENCE_OBJECTS_ID = "Id5bv1tAYt";

exports.MARKETPLACE_PUBLISHER_ID_ROMWOD = "sTpNHaFGFC";

exports.TRACK_WORKOUTOFTHEDAY = "workout-of-the-day";
exports.TRACK_WORKOUTOFTHEDAY_DISPLAY = "Workout of the Day";

exports.COMPLIMENTARY_AFFILIATE_IDS = []; //[exports.AFFILIATE_ID_ROOTS];

const useMasterKeyOption = { useMasterKey: true };

exports.PRVN_WORKOUT_PUBLISHER_ID = "Fc63AVJKAL";

exports.IOS_APP_STORE_URL =
    "https://itunes.apple.com/us/app/sugarwod/id665516348?mt=8";
exports.ANDROID_PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.flatironssoftware.sugarwod";

var strings;

// Date Formats
const dateFormats = {
    asInteger: "YYYYMMDD",
    lg: "dddd, MMM D, YYYY",
    md: "MMM D, YYYY",
    sm: "ddd, MMM D",
    sm2: "dddd, MMM D",
    xs: "MMM D",
    csv: "MM/DD/YYYY",
    monthyear: "MMM 'YY",
    monthKey: "YYYY-MM",
    scheduleTime: "h:mm A",
};

exports.WEEK_DAY_INDEX = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
};

// TRACK TYPES
exports.TBTrackType = {
    Public: 0, // normal group class programming
    PrivateGroup: 1, // private group class programming
    Personal: 2, // personal training
    Template: 3, // template of programming
};

var enumObjs = {};

// configurable track types are available to gym programmers as options when editing tracks
enumObjs[exports.TBTrackType.Public] = {
    id: "public",
    value: 0,
    display: "Public",
    configurable: true,
};
enumObjs[exports.TBTrackType.PrivateGroup] = {
    id: "private-group",
    value: 1,
    display: "Private Group",
    configurable: true,
};
enumObjs[exports.TBTrackType.Personal] = {
    id: "personal",
    value: 2,
    display: "Personal",
    configurable: false,
};
enumObjs[exports.TBTrackType.Template] = {
    id: "template",
    value: 3,
    display: "Template",
    configurable: false,
};
exports.TBTrackTypes = enumObjs;

// TIMELINE TYPES
exports.TBTrackTimelineType = {
    Absolute: 0, // default, "normal" date-for-date programming
    Relative: 1, // for progressive programming, cycles, etc
};
var enumObjsTimelineType = {};
enumObjsTimelineType[exports.TBTrackTimelineType.Absolute] = {
    id: "absolute",
    value: 0,
    display: "Absolute",
    description: 'default, "normal" date-for-date programming',
    startDateInt: null,
};
enumObjsTimelineType[exports.TBTrackTimelineType.Relative] = {
    id: "relative",
    value: 1,
    display: "Relative",
    description: "for progressive programming, cycles, etc",
    startDateInt: 19000101,
};
exports.TBTrackTimelineTypes = enumObjsTimelineType;

exports.TBMeasurementSystem = {
    Imperial: 0,
    Metric: 1,
};

exports.TBWorkoutLibraryType = {
    UNDEFINED: -1,

    BarbellLift: 0,
    Monostructural: 1,
    Gymnastics: 2,
    Girl: 3,
    Hero: 4,
    Notable: 5,
    Games: 6,
    Affiliate: 7,

    COUNT: 8,
};

strings = {};
strings[exports.TBWorkoutLibraryType.BarbellLift] = "Barbell Lifts";
strings[exports.TBWorkoutLibraryType.Monostructural] = "Endurance";
strings[exports.TBWorkoutLibraryType.Gymnastics] = "Gymnastics";
strings[exports.TBWorkoutLibraryType.Girl] = "Girls";
strings[exports.TBWorkoutLibraryType.Hero] = "Heroes";
strings[exports.TBWorkoutLibraryType.Notable] = "Notables";
strings[exports.TBWorkoutLibraryType.Games] = "Games";
strings[exports.TBWorkoutLibraryType.Affiliate] = "Gym Benchmarks";
exports.TBWorkoutLibraryTypeString = strings;

strings = {};
strings[exports.TBWorkoutLibraryType.BarbellLift] = "Barbell Lift";
strings[exports.TBWorkoutLibraryType.Monostructural] = "Endurance";
strings[exports.TBWorkoutLibraryType.Gymnastics] = "Gymnastics";
strings[exports.TBWorkoutLibraryType.Girl] = "Girl";
strings[exports.TBWorkoutLibraryType.Hero] = "Hero";
strings[exports.TBWorkoutLibraryType.Notable] = "Notable";
strings[exports.TBWorkoutLibraryType.Games] = "Games";
strings[exports.TBWorkoutLibraryType.Affiliate] = "Gym";
exports.TBWorkoutLibraryTypeStringSingular = strings;

// MONOSTRUCTURAL TYPE
exports.TBMonostructuralType = {
    UNDEFINED: -1,

    Run: 0,
    Row: 1,
    Ski: 2,
    Airdyne: 3,
    AssaultBike: 4,
    Concept2Bike: 5,
    EchoBike: 6,

    COUNT: 7,
};

strings = {};
strings[exports.TBMonostructuralType.Run] = "Run";
strings[exports.TBMonostructuralType.Row] = "Row";
strings[exports.TBMonostructuralType.Ski] = "Ski";
strings[exports.TBMonostructuralType.Airdyne] = "Airdyne";
strings[exports.TBMonostructuralType.AssaultBike] = "AssaultBike";
strings[exports.TBMonostructuralType.Concept2Bike] = "Concept2Bike";
strings[exports.TBMonostructuralType.EchoBike] = "EchoBike";
exports.TBMonostructuralTypeStringSingular = strings;

//MOVEMENT TYPE
exports.TBMovementType = {
    UNDEFINED: -1,

    Gymnastic: 0,
    Weighted: 1,
    Endurance: 2,

    Other: 3,
};

strings = {};
strings[exports.TBMovementType.UNDEFINED] = "Unknown";
strings[exports.TBMovementType.Gymnastic] = "Gymnastic";
strings[exports.TBMovementType.Weighted] = "Weighted";
strings[exports.TBMovementType.Endurance] = "Endurance";
strings[exports.TBMovementType.Other] = "Other";
exports.TBMovementTypeString = strings;

const TBVisibilityLevel = {
    UNDEFINED: -1,

    Private: 0,
    FriendsOnly: 1,
    FriendsAndAffiliate: 2,
    Public: 3,
};

const TBFriendStatus = {
    None: 0,
    Friends: 1,
    Pending: 2,
    Rejected: 3,
};

// notification types
const PUSH_NOTIFICATIONS = {
    Comment: 0,
    FriendRequest: 1,
    FriendAccept: 2,
    NewMember: 3,
    Feedback: 4,
    Fistbump: 5, // added 2.0.0
    PublishScheduledWorkout: 6, // added 2.0.0
    URL: 7, // added 2.0.0
    WorkoutResult: 8, // added 2.0.1, seems unused as of 5/10/17

    Waitlist: 9,
    Whiteboard: 11,
    FlaggedContentDeleted: 12,

    System: 999,
};
const PUSH_NOTIFICATION_TYPES = {};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.Whiteboard] = {
    id: PUSH_NOTIFICATIONS.Whiteboard,
    name: "Comment Posted on WhiteBoard",
    description:
        'Sent when a new WhiteBoard comment is added. "commentId" is the new comment, "athId" is the author, "targetId" is the object that was commented upon.',
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.Comment] = {
    id: PUSH_NOTIFICATIONS.Comment,
    name: "Comment Posted",
    description:
        'Sent when a new comment is added. "commentId" is the new comment, "athId" is the author, "targetId" is the object that was commented upon.',
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.FriendRequest] = {
    id: PUSH_NOTIFICATIONS.FriendRequest,
    name: "Friend Request Sent",
    description:
        'Sent when a an athlete requests another to "friend". "athId" is the athlete making the request.',
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.FriendAccept] = {
    id: PUSH_NOTIFICATIONS.FriendAccept,
    name: "Friend Request Accepted",
    description:
        'Sent when a an athlete accepts a friend request. "athId" is the athlete accepting.',
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.Fistbump] = {
    id: PUSH_NOTIFICATIONS.Fistbump,
    name: "Fistbump Given",
    description:
        'Sent when a a new fistbump is given. "athId" is the athlete giving the fistbump. "targetId" is the object fistbumped upon.',
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.PublishScheduledWorkout] = {
    id: PUSH_NOTIFICATIONS.PublishScheduledWorkout,
    name: "Workout Published",
    description:
        'Sent when a Scheduled Workout is published (i.e. able to be seen by athletes). "swId" is the workout being published, "affId" is the affiliate that the SW belongs to.',
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.URL] = {
    id: PUSH_NOTIFICATIONS.URL,
    name: "URL",
    description:
        "Used generically to send a message that can re-route to an URL.",
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.System] = {
    id: PUSH_NOTIFICATIONS.System,
    name: "System",
    description: "Used generically to send alerts.",
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.Waitlist] = {
    id: PUSH_NOTIFICATIONS.Waitlist,
    name: "Waitlist",
    description: "Scheduling reservation waitlist alert.",
};
PUSH_NOTIFICATION_TYPES[PUSH_NOTIFICATIONS.FlaggedContentDeleted] = {
    id: PUSH_NOTIFICATIONS.FlaggedContentDeleted,
    name: "Flagged Content Deleted",
    description:
        "Used to notify athlete that their content was flagged and deleted.",
};

exports.TBPushNotificationType = PUSH_NOTIFICATIONS; // for backwards compatibility in naming.

// WORKOUT PUB / SUB
const TBWorkoutPublisherType = {
    Private: 0,
    Marketplace: 1,
};
strings = {};
strings[TBWorkoutPublisherType.Private] = "Private";
strings[TBWorkoutPublisherType.Marketplace] = "Marketplace";

const TBWorkoutPublisherTypeString = strings;

// Workout Source for a Workout Result or Scheduled Workout
exports.TBWorkoutSourceType = {
    UNDEFINED: -1,
    Custom: 0,
    Library: 1,
    Affiliate: 2, // deprecated 3.0 // re-instated to support copying of SWs
    BarbellLift: 3,
    Endurance: 4,
};

exports.SCALING_OPTION_WORKOUTS = [
    exports.TBWorkoutSourceType.Custom,
    exports.TBWorkoutSourceType.BarbellLift,
    exports.TBWorkoutSourceType.Endurance,
];

// Scheduled Workout Type
exports.TBScheduledWorkoutType = {
    Workout: "workout",
    Video: "video",
};

const DELAY_PRIORITY = {
    CRITICAL: 1,
    HIGH: 5,
    MEDIUM: 50,
    NORMAL: 100,
    LOW: 1000,
};
const DELAY = {
    /* Algolia: 0-99 */
    ALGOLIA_AFFILIATE_SYNC: "algolia_affiliate_sync",
    ALGOLIA_AFFILIATE_REMOVE: "algolia_affiliate_remove",
    ALGOLIA_ATHLETE_SYNC: "algolia_athlete_sync",
    ALGOLIA_ATHLETE_REMOVE: "algolia_athlete_remove",

    ALGOLIA_SCHEDULED_WORKOUT_SYNC: "algolia_workout_sync",
    ALGOLIA_SCHEDULED_WORKOUT_REMOVE: "algolia_workout_remove",

    ALGOLIA_LIBRARY_WORKOUT_SYNC_WORKOUT: "algolia_libraryworkout_workout",
    ALGOLIA_LIBRARY_WORKOUT_SYNC_LIBRARY: "algolia_libraryworkout_library",
    ALGOLIA_LIBRARY_WORKOUT_REMOVE: "algolia_libraryworkout_remove",

    ALGOLIA_MOVEMENT_SYNC: "algolia_movement_sync",
    ALGOLIA_MOVEMENT_REMOVE: "algolia_movement_remove",

    ALGOLIA_PRODUCT_SYNC: "ALGOLIA_PRODUCT_SYNC",
    ALGOLIA_PRODUCT_REMOVE: "ALGOLIA_PRODUCT_REMOVE",

    ALGOLIA_DELETE_CANCELED_GYM_WORKOUT_RECORDS:
        "ALGOLIA_DELETE_CANCELED_GYM_WORKOUT_RECORDS",

    MAILCHIMP_ATHLETE_SYNC: "mailchimp_athlete_sync",
    MAILCHIMP_BRANDED_ATHLETE_SYNC: "mailchimp_branded_athlete_sync",
    MAILCHIMP_AFFILIATE_SYNC: "MAILCHIMP_AFFILIATE_SYNC",
    MAILCHIMP_CUSTOMER_SYNC: "mailchimp_customer_sync",
    MAILCHIMP_CUSTOMER_COACH_OWNER: "mailchimp_cco_sync", // I actually like this as a periodic job better than a delayed job.
    MAILCHIMP_UNSUBSCRIBE: "mailchimp_unsubscribe",
    MAILCHIMP_MAYHEM_UNSUBSCRIBE: "mailchimp_mayhem_unsubscribe",
    MAILCHIMP_PROJECTHOCKEY_UNSUBSCRIBE: "mailchimp_projecthockey_unsubscribe",
    MAILCHIMP_SUBSCRIBE_TRIAL_DRIP: "mailchimp_subscribe_trial_drip",
    MAILCHIMP_UNSUBSCRIBE_TRIAL_DRIP: "mailchimp_unsubscribe_trial_drip",

    /* Notifications: 100-199 */
    NOTIFICATION_FISTBUMP: "notification_fistbump",
    NOTIFICATION_COMMENT: "notification_comment",
    NOTIFICATION_ATHLETE_JOIN_AFFILIATE: "notification_athlete_join_affiliate",
    NOTIFICATION_GIVE_FISTBUMP: "NOTIFICATION_GIVE_FISTBUMP",
    NOTIFICATION_ADD_COMMENT: "NOTIFICATION_ADD_COMMENT",
    NOTIFICATION_REQUEST_FRIEND: "NOTIFICATION_REQUEST_FRIEND",
    NOTIFICATION_ADD_WHITEBOARD_COMMENT: "NOTIFICATION_ADD_WHITEBOARD_COMMENT",

    NOTIFICATION_PUSH_TO_ATHLETES: "NOTIFICATION_PUSH_TO_ATHLETES",

    /* Counters: 200-299 */
    COUNTERS_COMMENT_CREATED: "counts_comment_created",
    COUNTERS_COMMENT_DELETED: "counts_comment_deleted",

    /* STREAM */
    STREAM_ATHLETE_BOOTSTRAP_IF_NECESSARY: "stream_ath_bootstrap",

    STREAM_ATHLETE_FOLLOW_ATHLETE: "stream_ath_follow_ath",
    STREAM_ATHLETE_FOLLOW_AFFILIATE: "stream_ath_follow_aff",

    STREAM_ATHLETE_UNFOLLOW_ATHLETE: "stream_ath_unfollow_ath",
    STREAM_ATHLETE_UNFOLLOW_AFFILIATE: "stream_ath_unfollow_aff",

    STREAM_AFFILIATE_ATHLETE_JOIN: "stream_aff_ath_joined",
    STREAM_AFFILIATE_ATHLETE_LEAVE: "stream_aff_ath_left",

    STREAM_AFFILIATE_PUBLISHED_WORKOUT: "stream_aff_posted_sw",
    STREAM_AFFILIATE_UPDATED_WORKOUT: "stream_aff_updated_sw",
    STREAM_AFFILIATE_DELETED_WORKOUT: "stream_aff_deleted_sw",

    STREAM_WORKOUT_RESULT_POST: "stream_wr_post",
    STREAM_WORKOUT_RESULT_UPDATE: "stream_wr_update",
    STREAM_WORKOUT_RESULT_DELETE: "stream_wr_delete",
    STREAM_WORKOUT_RESULT_BIG_FISTBUMPS: "stream_wr_big_fistbumps",
    STREAM_WORKOUT_RESULT_BIG_COMMENTS: "stream_wr_big_comments",
    STREAM_WORKOUT_RESULT_PR_BENCHMARK: "stream_wr_pr_benchmark",

    STREAM_FEED_ITEM_CREATE: "stream_feed_item_create",
    STREAM_FEED_ITEM_UPDATE: "stream_feed_item_update",
    STREAM_FEED_ITEM_DELETE: "stream_feed_item_delete",

    // EMAIL
    SPARKPOST_SEND_EMAIL: "SPARKPOST_SEND_EMAIL",

    // EXPORTS
    EXPORT_ATHLETE_WORKOUT_RESULTS: "EXPORT_ATHLETE_WORKOUT_RESULTS",
    EXPORT_AFFILIATE_SCHEDULED_WORKOUTS: "EXPORT_AFFILIATE_SCHEDULED_WORKOUTS",

    // IMPORTS
    IMPORT_CREATE_WORKOUT_RESULT_LIBRARY:
        "IMPORT_CREATE_WORKOUT_RESULT_LIBRARY",
    IMPORT_CREATE_WORKOUT_RESULT_BARBELL_LIFT:
        "IMPORT_CREATE_WORKOUT_RESULT_BARBELL_LIFT",
    CALCULATE_PRS_FOR_LIBRARY_WORKOUT: "CALCULATE_PRS_FOR_LIBRARY_WORKOUT",
    CALCULATE_PRS_FOR_BARBELL_LIFT: "CALCULATE_PRS_FOR_BARBELL_LIFT",
    IMPORT_BBL_PRS: "IMPORT_BBL_PRS",
    IMPORT_GYM_BENCHMARKS_LIBRARY: "IMPORT_GYM_BENCHMARKS_LIBRARY",
    INTEGRATION_MEMBER_CONNECT: "INTEGRATION_MEMBER_CONNECT",

    // SALESFORCE TICKETING
    SALESFORCE_CREATE_TICKET: "SALESFORCE_CREATE_TICKET",

    // SLACK
    SLACK_SEND_MESSAGE: "SLACK_SEND_MESSAGE",

    // SW PUBLISHING
    PUBLISH_SCHEDULED_WORKOUT: "publish_scheduled_workout",
    AFFILIATE_PUBLISHING_SETTINGS_CHANGED:
        "affiliate_publishing_settings_changed",

    // ANALYTICS
    ANALYTICS_AFFILIATE_DAILY_ACTIVITY: "analytics_affiliate_daily_activity",
    ANALYTICS_SUGARWOD_DAILY_ACTIVITY: "analytics_sugarwod_daily_activity",
    ANALYTICS_SUGARWOD_DAILY_METRICS: "ANALYTICS_SUGARWOD_DAILY_METRICS",

    // MARKETPLACE
    MARKETPLACE_SUBSCRIPTION_PROCESS_EXPIRATION:
        "MARKETPLACE_SUBSCRIPTION_PROCESS_EXPIRATION",
    MARKETPLACE_SYNC_SUBSCRIPTION_FROM_STRIPE:
        "MARKETPLACE_SYNC_SUBSCRIPTION_FROM_STRIPE",

    // AFFILIATES
    AFFILIATE_ATHLETE_SYNC: "AFFILIATE_ATHLETE_SYNC",
    RECALCULATE_GMT_OFFSET: "RECALCULATE_GMT_OFFSET",
    AFFILIATE_WEEKLY_REPORT: "SEND_AFF_WEEKLY_REPORT",

    // ATHLETES
    ATHLETE_MOVE_OWNED_OBJECTS_TO_AFFILIATE:
        "ATHLETE_MOVE_OWNED_OBJECTS_TO_AFFILIATE",
    ATHLETE_DELETE_ALL_ATHLETE_OWNED_OBJECTS:
        "ATHLETE_DELETE_ALL_ATHLETE_OWNED_OBJECTS",
    WORKOUT_RESULT_ATHLETE_SYNC: "WORKOUT_RESULT_ATHLETE_SYNC",

    // SECURITY
    ATHLETE_ACCESS_PROCESS_EXPIRATION: "ATHLETE_ACCESS_PROCESS_EXPIRATION",
    SEND_DUPLICATE_ATHLETE_ACCESS_MESSAGE:
        "SEND_DUPLICATE_ATHLETE_ACCESS_MESSAGE",

    // CUSTOMERS
    CUSTOMER_PLAND_RECALCULATE_SUBSCRIPTION_TIER:
        "CUSTOMER_PLAND_RECALCULATE_SUBSCRIPTION_TIER",
    CUSTOMER_PLANE_RECALCULATE_SUBSCRIPTION_TIER:
        "CUSTOMER_PLANE_RECALCULATE_SUBSCRIPTION_TIER",
    CUSTOMER_RECALCULATE_SUBSCRIPTION_TIER:
        "CUSTOMER_RECALCULATE_SUBSCRIPTION_TIER",
    CUSTOMER_SUBSCRIPTION_PROCESS_EXPIRATION:
        "CUSTOMER_SUBSCRIPTION_PROCESS_EXPIRATION",

    // MARKETPLACE
    PUBLISHER_RECALCULATE_APPLICATION_FEE:
        "PUBLISHER_RECALCULATE_APPLICATION_FEE",
    STRIPE_SUBSCRIPTION_UPDATE_APPLICATION_FEE:
        "STRIPE_SUBSCRIPTION_UPDATE_APPLICATION_FEE",
    STRIPE_SUBSCRIPTION_UPDATE_COUPON: "STRIPE_SUBSCRIPTION_UPDATE_COUPON",

    SYNC_PUBLISHING_TRACKS_FOR_SUBSCRIBER:
        "SYNC_PUBLISHING_TRACKS_FOR_SUBSCRIBER",
    QUEUE_JOBS_TO_SYNC_PUBLISHING_TRACKS_FOR_SUBSCRIBERS:
        "QUEUE_JOBS_TO_SYNC_PUBLISHING_TRACKS_FOR_SUBSCRIBERS",

    // COMMENTS
    COMMENT_SEND_NOTIFICATIONS: "COMMENT_SEND_NOTIFICATIONS",
    COMMENT_REMOVE_FROM_SOURCE_OBJECT: "COMMENT_REMOVE_FROM_SOURCE_OBJECT",

    // GENERIC MONGO OPERATIONS
    UPDATE_OBJECT_ATTRIBUTE: "UPDATE_OBJECT_ATTRIBUTE",
    DELETE_OBJECT: "DELETE_OBJECT",

    // STRIPE
    STRIPE_UPDATE_CONNECTED_ACCOUNT: "STRIPE_UPDATE_CONNECTED_ACCOUNT",
    STRIPE_CREATE_CONNECTED_ACCOUNT_TAX_ID:
        "STRIPE_CREATE_CONNECTED_ACCOUNT_TAX_ID",
    STRIPE_CREATE_CUSTOMER_TAX_ID: "STRIPE_CREATE_CUSTOMER_TAX_ID",
    STRIPE_CUSTOMER_SYNC_ADDRESS_METADATA:
        "STRIPE_CUSTOMER_SYNC_ADDRESS_METADATA",

    // PROGRAMMING SUBSCRIPTIONS
    PROGRAMMING_SUBSCRIPTIONS_BROADCAST: "PROGRAMMING_SUBSCRIPTIONS_BROADCAST",
    PROGRAMMING_SUBSCRIPTIONS_SOURCE_WORKOUTS:
        "PROGRAMMING_SUBSCRIPTIONS_SOURCE_WORKOUTS",
    PROGRAMMING_SUBSCRIPTIONS_COPY_WORKOUT:
        "PROGRAMMING_SUBSCRIPTIONS_COPY_WORKOUT",

    KEEN_RECORD_FISTBUMP: "KEEN_RECORD_FISTBUMP",
    KEEN_RECORD_WHITEBOARD_VIEW: "KEEN_RECORD_WHITEBOARD_VIEW",
    KEEN_RECORD_APP_OPEN: "KEEN_RECORD_APP_OPEN",
    KEEN_RECORD_EVENT: "KEEN_RECORD_EVENT",

    // SECURITY
    SECURITY_GRANT_ACCESS: "SECURITY_GRANT_ACCESS",
    SECURITY_REVOKE_ACCESS: "SECURITY_REVOKE_ACCESS",

    // APP SUPPORT
    ATHLETE_DID_LOGIN: "ATHLETE_DID_LOGIN",

    // SYSTEM
    TEST_DELAY: "TEST_DELAY",
    JOB_QUEUE_HEALTH: "JOB_QUEUE_HEALTH",

    // WEB HOOKS
    ZENPLANNER_SYNC_MEMBERSHIP_TYPES: "ZENPLANNER_SYNC_MEMBERSHIP_TYPES",
    ZENPLANNER_NEW_MEMBERSHIP_TYPE: "ZENPLANNER_NEW_MEMBERSHIP_TYPE",
    ZENPLANNER_RESERVATION_NOTIFICATION: "ZENPLANNER_RESERVATION_NOTIFICATION",
    ZENPLANNER_PERSON_EVENTS: "ZENPLANNER_PERSON_EVENTS",

    //PUSH NOTIFICATION
    SEND_PARSE_PUSH_NOTIFICATION: "SEND_PARSE_PUSH_NOTIFICATION",
    SEND_PUSH_NOTIFICATION: "SEND_PUSH_NOTIFICATION",
    SEND_GROUP_PUSH_NOTIFICATION: "SEND_GROUP_PUSH_NOTIFICATION",
};

// MARKETPLACE
exports.MarketplaceProductType = {
    GROUP: 0,
    INDIVIDUAL: 1,
};

exports.MARKETPLACE_FREE_PURCHASE_ID = "ch_free_purchase";

// Errors
const ERROR = {
    ASSERT_FAIL: 999999,
    ATHLETE_MUST_HAVE_AFFILIATE: 1000001,
    USER_OBJECT_CORRUPT: 1000002,
    SAME_AFFILIATE_REQUIRED: 1000003,
    NOT_PERMITTED_WITH_HQ: 1000004,
    SUGAR_STATUS_REQUIRED: 1000006,
    PERMISSION_DENIED: 1000008,
    CLIENT_NOT_AUTHORIZED: 1000010,
    INVALID_SIGNUP_ATTEMPT: "INVALID_SIGNUP_ATTEMPT",

    ZP_INTEGRATION_DONTREPEAT: 2000000,
};

exports.ERROR_LEVEL = {
    ASSERT: 10,
    FATAL: 100,
};

exports.GYM_BUSINESS_TYPES = [
    {
        id: "affiliate",
        name: "CrossFit Affiliate",
    },

    {
        id: "non-affiliate",
        name: "S&C / HIIT / Gym Facility",
    },

    {
        id: "corporate",
        name: "Corporate Wellness",
    },

    {
        id: "ymca-jcc",
        name: "YMCA / JCC",
    },

    {
        id: "garage",
        name: "Garage Gym",
    },

    {
        id: "club",
        name: "Fitness Club",
    },

    {
        id: "online",
        name: "Online Fitness Community",
    },

    {
        id: "non-profit",
        name: "Non-profit / Military / School",
    },

    {
        id: "other",
        name: "Other",
    },
];

exports.GYM_MANAGEMENT_PLATFORMS = [
    {
        id: "acuity",
        name: "Acuity Scheduling",
    },

    {
        id: "boxchamp",
        name: "BoxChamp",
    },

    {
        id: "boxhub",
        name: "BoxHub",
    },

    {
        id: "boxhq",
        name: "The Box HQ",
    },

    {
        id: "cfdashboard",
        name: "CF Dashboard",
    },

    {
        id: "ezfacility",
        name: "EZ Facility",
    },

    {
        id: "fitchalk",
        name: "FitChalk",
    },

    {
        id: "gymmaster",
        name: "Gym Master",
    },

    {
        id: "influx",
        name: "Influx",
    },

    {
        id: "mbo",
        name: "MindBody Online",
    },

    {
        id: "p13",
        name: "Pike 13 (Front Desk)",
    },

    {
        id: "pp",
        name: "Push Press",
    },

    {
        id: "quickbooks",
        name: "Quick Books",
    },

    {
        id: "regibox",
        name: "RegiBox",
    },

    {
        id: "rhino",
        name: "RhinoFit",
    },

    {
        id: "rxgym",
        name: "Rx Gym",
    },

    {
        id: "teamup",
        name: "TeamUp",
    },

    {
        id: "triib",
        name: "Triib",
    },

    {
        id: "virtuagym",
        name: "VirtuaGym",
    },

    {
        id: "wodboard",
        name: "WODBoard",
    },

    {
        id: "wodify",
        name: "Wodify",
    },

    {
        id: "wodhopper",
        name: "WOD Hopper",
    },

    {
        id: "wodhub",
        name: "WOD Hub",
    },

    {
        id: "wodtogether",
        name: "WodTogether",
    },

    {
        id: "wodboard",
        name: "Wodboard",
    },

    {
        id: "zp",
        name: "Zen Planner",
    },

    {
        id: "csi",
        name: "CSI Spectrum",
    },

    {
        id: "ca",
        name: "Club Automation",
    },

    {
        id: "none",
        name: "None / Manual / Custom System",
    },

    {
        id: "other",
        name: "Other",
    },
];

exports.GYM_PROGRAMMING_SOURCES = [
    {
        id: "self",
        name: "We write our own workout programming.",
    },

    {
        id: "mainsite",
        name: "CrossFit.com Mainsite WOD",
    },

    {
        id: "box-programming",
        name: "Box Programming / Jason Brown",
    },

    {
        id: "built-by-bergeron",
        name: "CompTrain / Ben Bergeron",
    },

    {
        id: "ham-plan",
        name: "HAM / Austin Malleolo & Spencer Hendel",
    },

    {
        id: "hyperfit",
        name: "HyperFit / Doug Chapman",
    },

    {
        id: "icon-athlete",
        name: "IconAthlete / Chris Spealler",
    },

    {
        id: "invictus",
        name: "CrossFit Invictus",
    },

    {
        id: "linchpin",
        name: "CrossFit Linchpin / Pat Sherwood",
    },

    {
        id: "misfit",
        name: "MisFit Athletics",
    },

    {
        id: "thrivestry",
        name: "Thrivestry",
    },

    {
        id: "warmup-and-workout",
        name: "Warmup & Workout / Pat & Taz Barber",
    },

    {
        id: "other",
        name: "Other",
    },
];

exports.GYM_CUSTOMER_CANCELATION_REASONS = [
    {
        adminOnly: true,
        id: "Stripe initiated.",
        name: "Stripe initiated.",
        detailsPrompt: "",
    },

    {
        adminOnly: true,
        id: "stripe-initiated",
        name: "Stripe initiated.",
        detailsPrompt: "",
    },

    {
        adminOnly: false,
        id: "covid-19",
        name: "COVID-19 Issues",
        detailsPrompt: "",
    },

    {
        adminOnly: false,
        id: "gym-closing",
        name: "Gym Closing",
        detailsPrompt: "",
    },

    {
        adminOnly: false,
        id: "all-in-one",
        name: "Switching Platform",
        detailsPrompt: "",
    },

    {
        adminOnly: true,
        id: "btwb",
        name: "Switching to BTWB",
        detailsPrompt: "",
    },

    {
        adminOnly: true,
        id: "zenplanner",
        name: "Switching to ZenPlanner",
        detailsPrompt: "",
    },

    {
        adminOnly: true,
        id: "wodboard",
        name: "Switching to WODBoard",
        detailsPrompt: "",
    },

    {
        adminOnly: true,
        id: "wodify",
        name: "Switching to Wodify",
        detailsPrompt: "",
    },

    {
        adminOnly: true,
        id: "triib",
        name: "Switching to Triib",
        detailsPrompt: "",
    },

    {
        adminOnly: true,
        id: "switch-other",
        name: "Switching to Other",
        detailsPrompt: "",
    },

    {
        adminOnly: true,
        id: "language",
        name: "Foreign language",
        detailsPrompt: "",
    },

    {
        adminOnly: false,
        id: "missing-functionality",
        name: "Missing feature(s)",
        detailsPrompt: "What features are missing?",
    },

    {
        adminOnly: true,
        id: "non-payment",
        name: "Failure to pay",
        detailsPrompt: "",
    },

    {
        adminOnly: false,
        id: "price",
        name: "Price",
        detailsPrompt: "",
    },

    {
        adminOnly: false,
        id: "not-being-used",
        name: "Athlete Use",
        detailsPrompt: "",
    },

    {
        adminOnly: false,
        id: "bad-fit",
        name: "Doesn't fit my gym’s needs",
        detailsPrompt:
            "Can you provide any feedback on how SugarWOD doesn't fit your gym?",
    },

    {
        adminOnly: false,
        id: "sold-gym",
        name: "Sold gym",
        detailsPrompt: "Should we transfer your account instead?",
    },

    {
        adminOnly: true,
        id: "unknown",
        name: "Unknown",
        detailsPrompt: "",
    },

    {
        adminOnly: false,
        id: "other",
        name: "Other",
        detailsPrompt: "",
    },
];

exports.EVENTS = {
    CF_OPEN: {
        currentYear: 2021,
        2021: {
            id: "2021-cf-open",
            endDate: "2021-03-30",
            pollAnswers: {
                inOpen: false,
                showFrame: false,
            },
        },
    },
};

// programming levels
exports.SUGARWOD_DEFAULT_LEVEL_ID = "dEBJrc3Zb0";

exports.SUGARWOD_PROGRAMMING_LEVELS = [
    {
        id: "dEBJrc3Zb0",
        displayName: "RX/Scaled",
        levels: [
            {
                id: "633b8d23-1b79-4906-a14b-351ebc33d46d",
                displayName: "RX",
                rankValue: 2,
            },
            {
                id: "ce5a80ee-159b-4387-ad0d-267d532e8840",
                displayName: "Scaled",
                rankValue: 1,
            },
        ],
    },
    {
        id: "ErSFQwo0NK",
        displayName: "No Scaling",
        levels: [],
    },
];

const US_STATE_CODES = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
];

const WORKOUT_SCALING_OPTIONS = {
    0: {
        id: 0,
        label: "None",
        description: "No scaling option selections will be shown",
        isDefaultForNew: true,
        isDefaultForExisting: false,
    },
    1: {
        id: 1,
        label: "RX, Scaled",
        description: "RX, Scaled selection is required when logging a score",
        isDefaultForNew: false,
        isDefaultForExisting: true,
    },
};
const DEFAULT_SCALING_OPTION_NEW = Object.values(WORKOUT_SCALING_OPTIONS).find(
    (option) => option.isDefaultForNew
);
const DEFAULT_SCALING_OPTION_EXISTING = Object.values(
    WORKOUT_SCALING_OPTIONS
).find((option) => option.isDefaultForExisting);

const STANDARD_A_PLAN_ID = "MPavOwtjKe";
const STANDARD_B_PLAN_ID = "GbitI4eFuT";
const STANDARD_C_PLAN_ID = "qHo5r2D1WT";
const STANDARD_D_PLAN_ID = "5u3xhEAvyS";
const STANDARD_E_PLAN_ID = "7sGBk7XqX0";
const STANDARD_F_PLAN_ID = "RxZmvNQHzr";
const STANDARD_G_PLAN_ID = "cx9BcQqvl8";
const STANDARD_H_PLAN_ID = "DIaoVV6tEr"; // NOTE: After you update run the migrate script you need to update with the id from production from TB_SubscriptionPlan
const STANDARD_EARLYBIRD_PLAN_ID = "BqaOuPnmM1";
const COMPLIMENTARY_PROMOTIONAL_PLAN_ID = "59EuZBc70c";
const NON_COMMERCIAL_CARD_REQ_PLAN_ID = "zeds2eshUT";
const NON_COMMERCIAL_NO_CARD_PLAN_ID = "iHBzNd5fwZ";
const MARKET_PLACE_PARTNER_GYM_PLAN_ID = "jWGpPnQpMk";
const STANDARD_D_FREE_TIER_ID = "Z0AL7JTnsJ";
const STANDARD_E_BASE_TIER_ID = "xVJDE9HIO2";

const CSRF_ERROR_CODE = "EBADCSRFTOKEN";
const SESSION_COOKIE_NAME = "_sw_session";

const ECOMMERCE_BASE_API_URL = process.env.ECOMMERCE_BASE_API_URL;
const SHOPIFY_CHECKOUT_API = process.env.SHOPIFY_CHECKOUT_API;
const SUGARWOD_ECOMMERCE_CONTEXT_APP_ID =
    process.env.SUGARWOD_ECOMMERCE_CONTEXT_APP_ID;

const AFFILIATE_IDS = {
    MAYHEM: "Xp0fWUGpoR",
    PROJECT_HOCKEY: "qNQHyQCSKO",
    PRVN_FITNESS: "cQdoKyyqdl",
    SUGARWOD_DEMO_GYM: "EkAlWLwTxm",
    TRAIN_HARD: "fGimDzDm2H", // NCFIT
    CROSSFIT_SUGARWOD_TEST_2: "QbUKTfKFvo",
    CF_MAINSITE: "hEvyyT2IQA",
};

const PUBLISHER_IDS = {
    TRAIN_HARD: "LNnNDSd2q4", // NCFIT
};

const ACL_ROLE_PERMISSIONS = {
    PUBLIC_READ: 1,
    PUBLIC_WRITE: 2,
    USER_READ: 4,
    USER_WRITE: 8,
    ATHLETE_READ: 16,
    ATHLETE_WRITE: 32,
    STAFF_READ: 64,
    STAFF_WRITE: 128,
    FRIENDSHIP_READ: 256,
    FRIENDSHIP_WRITE: 512,
};

module.exports.ACL_ROLE_PERMISSIONS = ACL_ROLE_PERMISSIONS;

const DEFAULT_TRIAL_DURATION_DAYS = 14;

module.exports.AFFILIATE_IDS = AFFILIATE_IDS;
module.exports.CSRF_ERROR_CODE = CSRF_ERROR_CODE;
module.exports.DELAY = DELAY;
module.exports.DELAY_PRIORITY = DELAY_PRIORITY;
module.exports.ECOMMERCE_BASE_API_URL = ECOMMERCE_BASE_API_URL;
module.exports.EMAIL_TECHNICAL_ADMIN = EMAIL_TECHNICAL_ADMIN;
module.exports.ERROR = ERROR;
module.exports.SESSION_COOKIE_NAME = SESSION_COOKIE_NAME;
module.exports.SHOPIFY_CHECKOUT_API = SHOPIFY_CHECKOUT_API;
module.exports.SUGARWOD_ECOMMERCE_CONTEXT_APP_ID =
    SUGARWOD_ECOMMERCE_CONTEXT_APP_ID;
module.exports.SUGARWOD = SUGARWOD;
module.exports.SUGARWOD_MARKETPLACE_NAME = SUGARWOD_MARKETPLACE_NAME;
module.exports.TBWorkoutPublisherType = TBWorkoutPublisherType;
module.exports.TBWorkoutPublisherTypeString = TBWorkoutPublisherTypeString;
module.exports.TBVisibilityLevel = TBVisibilityLevel;
module.exports.TBFriendStatus = TBFriendStatus;

module.exports.STANDARD_A_PLAN_ID = STANDARD_A_PLAN_ID;
module.exports.STANDARD_B_PLAN_ID = STANDARD_B_PLAN_ID;
module.exports.STANDARD_C_PLAN_ID = STANDARD_C_PLAN_ID;
module.exports.STANDARD_D_PLAN_ID = STANDARD_D_PLAN_ID;
module.exports.STANDARD_E_PLAN_ID = STANDARD_E_PLAN_ID;
module.exports.STANDARD_F_PLAN_ID = STANDARD_F_PLAN_ID;
module.exports.STANDARD_G_PLAN_ID = STANDARD_G_PLAN_ID;
module.exports.STANDARD_H_PLAN_ID = STANDARD_H_PLAN_ID;
module.exports.STANDARD_EARLYBIRD_PLAN_ID = STANDARD_EARLYBIRD_PLAN_ID;
module.exports.COMPLIMENTARY_PROMOTIONAL_PLAN_ID =
    COMPLIMENTARY_PROMOTIONAL_PLAN_ID;
module.exports.NON_COMMERCIAL_CARD_REQ_PLAN_ID =
    NON_COMMERCIAL_CARD_REQ_PLAN_ID;
module.exports.NON_COMMERCIAL_NO_CARD_PLAN_ID = NON_COMMERCIAL_NO_CARD_PLAN_ID;
module.exports.MARKET_PLACE_PARTNER_GYM_PLAN_ID =
    MARKET_PLACE_PARTNER_GYM_PLAN_ID;
module.exports.STANDARD_D_FREE_TIER_ID = STANDARD_D_FREE_TIER_ID;
module.exports.STANDARD_E_BASE_TIER_ID = STANDARD_E_BASE_TIER_ID;
module.exports.AFFILIATE_ID_HQ = AFFILIATE_ID_HQ;
module.exports.dateFormats = dateFormats;
module.exports.useMasterKeyOption = useMasterKeyOption;
module.exports.PUBLISHER_IDS = PUBLISHER_IDS;
module.exports.US_STATE_CODES = US_STATE_CODES;
module.exports.DEFAULT_TRIAL_DURATION_DAYS = DEFAULT_TRIAL_DURATION_DAYS;
module.exports.WORKOUT_SCALING_OPTIONS = WORKOUT_SCALING_OPTIONS;
module.exports.DEFAULT_SCALING_OPTION_NEW = DEFAULT_SCALING_OPTION_NEW;
module.exports.DEFAULT_SCALING_OPTION_EXISTING =
    DEFAULT_SCALING_OPTION_EXISTING;
